<div class="dialog-viewer">
    <h2 mat-dialog-title>Edit Member</h2>
    <form [formGroup]="form" (ngSubmit)="submit(form)">
        <mat-dialog-content>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>First Name</mat-label>
                            <input required matInput name="firstName" id="firstName" placeholder="First Name" type="text"
                                formControlName="firstName" />
                            <mat-error *ngIf="form.get('firstName').errors?.required">First Name is required</mat-error>
                            <mat-error *ngIf="form.get('firstName').errors?.validationErrors">
                                {{ form.get("firstName").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>Last Name</mat-label>
                            <input required matInput name="lastName" id="lastName" placeholder="Last Name" type="text"
                                formControlName="lastName" />
                            <mat-error *ngIf="form.get('lastName').errors?.required">Last Name is required</mat-error>
                            <mat-error *ngIf="form.get('lastName').errors?.validationErrors">
                                {{ form.get("lastName").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>Email</mat-label>
                            <input matInput name="email" id="email" placeholder="Email (optional)" type="email"
                                formControlName="email" />
                            <mat-error *ngIf="form.get('email').errors?.email">Please enter a valid email address</mat-error>
                            <mat-error *ngIf="form.get('email').errors?.validationErrors">
                                {{ form.get("email").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="text-center">
                <button mat-raised-button type="submit" [disabled]="isLoading || form.invalid">Save</button>
                <button mat-raised-button type="button"  class="warning" (click)="dialogRef.close('cancel')" [disabled]="isLoading">
                    Cancel
                </button>
            </div>
        </mat-dialog-actions>
    </form>
</div>

